__turbopack_context__.v({
  "border": "_2rRlOG_border",
  "content": "_2rRlOG_content",
  "dialog": "_2rRlOG_dialog",
  "footer": "_2rRlOG_footer",
  "header": "_2rRlOG_header",
  "shadow": "_2rRlOG_shadow",
});
